// extracted by mini-css-extract-plugin
module.exports = {"root":"style-module__root___3gdsi","dropZone":"style-module__dropZone___307db","image":"style-module__image___1cjwN","removeImage":"style-module__removeImage___1rNwv"};